/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'note-list-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M4 6v17.5A1.502 1.502 0 0 0 5.5 25h14a1.502 1.502 0 0 0 1.5-1.5V6zm4.5 13a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5zm0-4a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5zm0-4a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5zm8 8h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zm0-4h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zm0-4h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zM19.5 2H18V.5a.5.5 0 0 0-1 0V2h-4V.5a.5.5 0 0 0-1 0V2H8V.5a.5.5 0 0 0-1 0V2H5.5A1.502 1.502 0 0 0 4 3.5V5h17V3.5A1.502 1.502 0 0 0 19.5 2z"/>'
  }
})
